import React from "react";
import isEmpty from "../../../store/validations/is-empty";

function DisplaySelectedOptionsList({
  extraClassName,
  displayListSelected,
  handleRemoveMember,
  placeholder,
  isDisplayRemoveIcon,
}) {
  return (
    !isEmpty(displayListSelected) && (
      <div
        className={`${extraClassName} d-flex flex-wrap mt-display-selected-options-list`}
      >
        {displayListSelected.map((data, index) => (
          <div
            key={index}
            className="custom-d-flex flex-nowrap align-items-center mt-display-selected-options-list__card"
          >
            <input
              type="text"
              value={data.label}
              placeholder={placeholder}
              readOnly
            />
            {isDisplayRemoveIcon && (
              <button onClick={handleRemoveMember(index)}>
                <i className="fa fa-times"></i>
              </button>
            )}
          </div>
        ))}
      </div>
    )
  );
}

DisplaySelectedOptionsList.defaultProps = {
  isDisplayRemoveIcon: true,
  extraClassName: "",
  placeholder: "",
};

export default DisplaySelectedOptionsList;
